import React from 'react';
import '../../css/promotionalItems.css';

import airfresher from '../../image/promotional items/airfresher.webp';
import bag from '../../image/promotional items/bag.webp';
import bottle from '../../image/promotional items/bottle.webp';
import pen from '../../image/promotional items/pen.webp';
import smalbag from '../../image/promotional items/smalbag.webp';
import stand from '../../image/promotional items/stand.webp';
import tshirt from '../../image/promotional items/tshirt.webp';
import wippers from '../../image/promotional items/wippers.webp';

const PromotionalItems = () => {
  const items = [
    { name: 'Air Freshener', img: airfresher },
    { name: 'Bag', img: bag },
    { name: 'Bottle', img: bottle },
    { name: 'Pen', img: pen },
    { name: 'Small Bag', img: smalbag },
    { name: 'Stand', img: stand },
    { name: 'T-Shirt', img: tshirt },
    { name: 'Wipers', img: wippers }
  ];

  // Duplicate items to create a seamless infinite scroll effect
  const scrollItems = [...items, ...items, ...items];

  return (
    <section className="promotional-section py-5">

      <div className="text-center mb-5">
        <div className="d-inline-flex align-items-center gap-2 mb-2">
          <div style={{ width: "40px", height: "3px", backgroundColor: "#e86229", borderRadius: "2px" }}></div>
          <h6 className="fw-bold text-uppercase mb-0" style={{ color: '#e86229', letterSpacing: '2px' }}>
            Promotional Items
          </h6>
          <div style={{ width: "40px", height: "3px", backgroundColor: "#e86229", borderRadius: "2px" }}></div>
        </div>
        <h2 className="fw-bold display-5 top-category-heading" style={{ color: '#1a2f55', fontFamily: "'Georgia', serif" }}>
          Franchise promotional Items
        </h2>
      </div>

      <div className="scroller-container">
        <div className="scroller-track">
          {scrollItems.map((item, index) => (
            <div key={index} className="scroller-item shadow-sm">
              <div className="img-container">
                <img src={item.img} alt={item.name} className="img-fluid rounded" loading="lazy" />
              </div>
              <h5 className="item-name mt-3">{item.name}</h5>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromotionalItems;
